import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import {persistor,store} from "./redux/store";
import "./index.css";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store} dir="rtl">
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

reportWebVitals();
